module.exports = __webpack_public_path__ + "img/Other Bistro.5e73a669.svg";